export default __webpack_public_path__ + "static/media/gallery12.45d5b83f.jpg";